import React from "react";
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import { ToastContainer, ToastStore } from "react-toasts";
import Cropper from "react-cropper";
import InputNumber from "react-input-just-numbers";
import "cropperjs/dist/cropper.css";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";
import ExifRotate from "exif-rotate-js";
import MetaTags from "react-meta-tags";
import Switch from "react-switch";

import FrameBuilderStyles from "./FrameBuilder.css";
import calculator from "./PriceCalculator.js";

import DropdownSelect from "./DropdownSelect.js";

import HelpModal from "./HelpModal.js";
import WarningMessage from "./WarningMessage";
/* eslint-disable import/no-webpack-loader-syntax */

import GuideIcon from "-!svg-react-loader!../icons/guide.svg";
import DropdownOrangeIcon from "-!svg-react-loader!../icons/dropdown-orange.svg";
import UploadIcon from "-!svg-react-loader!../icons/upload.svg";
import CropIcon from "-!svg-react-loader!../icons/crop.svg";
import DoneIcon from "-!svg-react-loader!../icons/done.svg";
import FitIcon from "-!svg-react-loader!../icons/fit.svg";
import RemoveIcon from "-!svg-react-loader!../icons/remove.svg";
import HelpIcon from "-!svg-react-loader!../icons/help.svg";
import ImageIcon from "-!svg-react-loader!../icons/image-2.svg";
import ZoomInIcon from "-!svg-react-loader!../icons/zoom-in.svg";
import ZoomOutIcon from "-!svg-react-loader!../icons/zoom-out.svg";
import FrameSizeImage from "../images/artwork-size.png";
import DisclaimerImage from "../images/Warning-2.svg";
import BackToBuilderImage from "-!svg-react-loader!../icons/back-to-builder.svg";
import VideoImage from "../images/video_image_builder.png";

import Ellipse from "-!svg-react-loader!../images/Ellipse_5.svg";
import Ellipse2 from "-!svg-react-loader!../images/Ellipse_6.svg";
import Polygon from "-!svg-react-loader!../images/Polygon_3.svg";

import utilities from "./Utilities";
import FrameBuilderBottom from "./FrameBuilderBottom";

let Calculator = new calculator();
let Utilities = new utilities();

const matteArray = [
  { frame: 0, style: 0 },
  { frame: 70, style: 1.5 },
  { frame: 110, style: 2 },
  { frame: 115, style: 2.5 },
  { frame: 130, style: 2.5 },
  { frame: 500, style: 3 },
];

export default class FrameBuilder extends React.Component {
  constructor(props) {
    // setTimeout(function() {
    //     debugger;
    // }.bind(this), 5000);

    super(props);

    this.state = {
      helpModal: null,
      section: "",
      id: "new",
      frameStyle: null,
      frameSelected: false,
      customSizes: true,

      currentCollection: [],
      currentGalleryImage: null,

      // artworkHeight: 43.2,
      // artworkWidth: 27.9,
      //
      // artworkHeightNominal: 43.2,
      // artworkWidthNominal: 27.9,
      //
      // externalHeight: 46.1,
      // externalWidth: 30.8,
      //
      // windowHeight: 42.1,
      // windowWidth: 26.8,
      //
      // matteBoardHeight: 43.2,
      // matteBoardWidth: 27.9,
      //
      // internalHeight: 43.3,
      // internalWidth: 28,
      //
      // rabbetEdgeHeightNominal: 42.1,
      // rabbetEdgeWidthNominal: 26.8,

      matteWidth: 2,
      glazing: null,
      backing: null,
      matteColor: null,
      addeddToCart: false,
      popularSize: null,
      suggestedMatteWidth: false,
      quantity: null,
      statusMsg: null,
      statusMsgFull: null,
      frameId: null,

      frameHeight: 200,
      frameWidth: 0,
      frameBorderWidth: 20,
      frameColor: "fff",
      matColorSelected: false,
      previewMatteColor: "fff",
      previewMatteWidth: 0,

      previewImgLoaded: false,
      croppedImage: null,
      isCropping: false,
      previewImg: null,
      originalImg: null,
      zoomLevel: 0,
      cropOnZoomSet: false,
      frameImgUrl: null,

      advancedOptionsDropdown: false,
      videoClicked: false,
      frameMinimum: 1.5,
      checked: false,
      matBorderCounter: 0,
      isOverSized: false,
    };
  }

  handleMatBorderChange = (checked) => {
    checked
      ? this.handleInputChange("matteWidth", 2)
      : this.handleInputChange("matteWidth", 0);
    // console.log(this.state.matBorderCounter);
    // checked
    //   ? Calculator.setMatteWidth(this.state.matteWidth)
    //   : Calculator.setMatteWidth(0);
    // // !checked && Calculator.setMatteColor("none");

    // this.setState({
    //   checked,
    //   matteWidth: checked ? this.state.matteWidth : 0
    // });

    // this.handleInputChange(
    //   "matteWidth",
    //   this.state.matBorderCounter === 0 ? 2 : this.state.matteWidth
    // );

    checked ? Calculator.setMatteWidth(2) : Calculator.setMatteWidth(0);
    // !checked && Calculator.setMatteColor("none");

    this.setState({ suggestedMatteWidth: false, checked, matteWidth: checked ? 2 : 0 });
  };

  removeImage = () => {
    this.setState(
      {
        previewImgLoaded: false,
        croppedImage: null,
        previewImg: null,
        isCropping: false,
        originalImg: null,
        rawImage: undefined,
      },
      function() {
        this.onResize();
      }
    );
  };

  cancelCrop = () => {
    this.setState(
      {
        isCropping: false,
      },
      function() {
        this.onResize();
      }
    );
  };

  crop = () => {
    let file = this.refs.cropper
      .getCroppedCanvas()
      .toDataURL("image/jpeg", 0.9);

    this.setState(
      {
        rawImage: null,
        croppedImage: null,
        previewImg: file,
        isCropping: false,
        zoomLevel: 0,
      },
      function() {
        this.onResize();
      }
    );
  };

  onFrameChange = (frameId) => {
    // console.log("FRAME CHANGE+++++++++++++++++++++++++++++++++++ " + frameId);

    let frameImages = localStorage.getItem("frameImages");

    if (frameImages) {
      frameImages = JSON.parse(frameImages);
      let priceDefinitions = JSON.parse(
        localStorage.getItem("priceDefinitions")
      );
      let frame_id = null;

      priceDefinitions
        .filter((item) => item.type === "frame")
        .map((item) => {
          // Problem lies here
          // console.log(frameId);
          if (item.adminId === frameId) {
            frame_id = item._id;
          }
          return item;
        });

      if (frame_id) {
        // console.log("GOT ACTUAL frame id " + frame_id, frameImages);

        let currentCollection = [];

        for (let key in frameImages.images) {
          let parts = key.split("-");
          let headerId = parts[0];
          let frameIda = parts[1];

          if (frame_id === frameIda) {
            let headerFileName = null;

            for (let headerKey in frameImages.headers) {
              if (frameImages.headers[headerKey]._id === headerId) {
                headerFileName = frameImages.headers[headerKey].name;
              }
            }

            currentCollection.push({
              headerId: headerId,
              frameId: frame_id,
              frameFileName: frameImages.images[key],
              headerFileName: headerFileName,
            });
          }
        }

        // console.log("END", currentCollection);

        this.setState({
          currentCollection: currentCollection,
        });
      }
    }
  };

  selectGalleryImage = (id) => {
    console.log("Seleting galery image: ", id);

    this.setState({
      currentGalleryImage: id,
    });
  };

  resaveToLocal = () => {
    let cartItem = JSON.parse(localStorage.getItem(this.state.id));

    cartItem.artworkWidth = this.state.artworkWidth;
    cartItem.artworkHeight = this.state.artworkHeight;

    cartItem.artworkWidthNominal = this.state.artworkWidthNominal;
    cartItem.artworkHeightNominal = this.state.artworkHeightNominal;

    // cartItem.frameWidthNominal = this.state.frameWidthNominal;
    // cartItem.frameHeightNominal = this.state.frameHeightNominal;

    cartItem.externalWidthNominal = this.state.externalWidthNominal;
    cartItem.externalHeightNominal = this.state.externalHeightNominal;

    cartItem.windowWidthNominal = this.state.windowWidthNominal;
    cartItem.windowHeightNominal = this.state.windowHeightNominal;
    cartItem.isOverSized = this.state.isOverSized;

    (cartItem.matteBoardHeight = this.state.matteBoardHeight),
      (cartItem.matteBoardWidth = this.state.matteBoardWidth),
      (cartItem.internalHeight = this.state.internalHeight),
      (cartItem.internalWidth = this.state.internalWidth),
      (cartItem.rabbetEdgeHeight = this.state.rabbetEdgeHeight),
      (cartItem.rabbetEdgeWidth = this.state.rabbetEdgeWidth),
      (cartItem.frameStyle = this.state.frameStyle);
    cartItem.matteWidth = this.state.matteWidth;
    cartItem.glazing = this.state.glazing;
    cartItem.hanging = this.state.hanging;
    cartItem.backing = this.state.backing;
    cartItem.addeddToCart = this.state.addeddToCart;
    cartItem.matteColor = this.state.matteColor;
    cartItem.matteId = Calculator.getMatteIdByColor(
      Utilities.isOverSized(
        Calculator.calculatedValues.matteBoardHeight,
        Calculator.calculatedValues.matteBoardWidth
      )
    );
    // console.log(cartItem.matteId);
    //
    cartItem.popularSize = this.state.popularSize;
    cartItem.customSizes = this.state.customSizes;
    cartItem.quantity = this.state.quantity;
    cartItem.suggestedMatteWidth = this.state.suggestedMatteWidth;
    cartItem.frameId = this.state.frameId;
    cartItem.frameSelected = this.state.frameSelected;
    cartItem.matBorderSelected = this.state.checked;
    cartItem.matBorderCounter = this.state.matBorderCounter;
    cartItem.matColorSelected = this.state.matColorSelected;
    cartItem.isOverSized = Utilities.isOverSized(
      Calculator.calculatedValues.matteBoardHeight,
      Calculator.calculatedValues.matteBoardWidth
    );

    localStorage.setItem(this.state.id, JSON.stringify(cartItem));

    let status = Calculator.calculate();
    if (status.success === false) {
      // setTimeout(function() {
      this.setState({
        statusMsg: status.message,
      });
      // }.bind(this), 300)
    } else {
      this.setState({
        statusMsg: null,
      });
      let node = document.getElementById("frame-builder-price");
      if (node !== null) {
        node.innerHTML =
          window.currency +
          Calculator.calculatedValues.totalCost +
          "<span> (Price includes delivery)</span>";
      }
    }

    // }.bind(this), 1000)

    //TODO timeout and get new values from Calculator
  };

  componentDidMount() {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    document.title =
      window.globalVars.pageTitleBefore +
      "Custom Frame Builder" +
      window.globalVars.pageTitleAfter;

    window.addEventListener("resize", this.onResize);

    let priceDefinitions = JSON.parse(localStorage.getItem("priceDefinitions"));

    if (Utilities.isENU(priceDefinitions)) {
      //ToastStore.error("We couldn't load the frame builder, please try again in a minute");
      this.setState({
        statusMsgFull: "We couldn't load the frame builder, please try again",
      });
      setTimeout(function() {
        window.location.reload();
      }, 5000);
      return;
    }

    let id = window.location.href;
    id = id.substr(id.lastIndexOf("/") + 1);

    let cart = JSON.parse(localStorage.getItem("cart"));
    let cartItem = JSON.parse(localStorage.getItem(id));

    if (Utilities.isENU(cartItem)) {
      window.location.href = "/";
    }

    let url = window.location.href;
    let parts = url.split("/");

    let newState = {
      section: parts[4],
      id: parts[5],
    };

    // let numArr2 = [];

    // let frame2 = Math.max(newState.artworkHeight, newState.artworkWidth);

    // matteArray.forEach(num => {
    //   if (num.frame > frame2) {
    //     numArr2.push(num.style);
    //   }
    // });

    // console.log(numArr2[0]);

    newState.artworkHeight = cartItem.artworkHeight;
    Calculator.setArtworkHeight(newState.artworkHeight);
    newState.artworkWidth = cartItem.artworkWidth;
    Calculator.setArtworkWidth(newState.artworkWidth);
    newState.matteWidth = cartItem.matteWidth;
    Calculator.setMatteWidth(newState.matteWidth);
    newState.glazing = cartItem.glazing;
    Calculator.setGlazing(newState.glazing);
    newState.backing = cartItem.backing;
    Calculator.setBacking(newState.backing);

    !cartItem.matColorSelected
      ? (newState.matteColor = Utilities.setMatBorderColor(
          cartItem.artworkHeight,
          cartItem.artworkWidth
        ))
      : (newState.matteColor = cartItem.matteColor);

    //  this effects all the colours ^^
    Calculator.setMatteColor(newState.matteColor);
    newState.hanging = cartItem.hanging;
    Calculator.setHanging(newState.hanging);

    newState.matteId = cartItem.matteId;
    newState.addeddToCart = cartItem.addeddToCart;
    newState.popularSize = cartItem.popularSize;
    newState.customSizes = cartItem.customSizes;
    newState.suggestedMatteWidth = cartItem.suggestedMatteWidth;
    newState.quantity = cartItem.quantity;

    newState.frameWidthNominal = cartItem.frameWidthNominal;
    newState.frameHeightNominal = cartItem.frameHeightNominal;
    newState.externalWidthNominal = cartItem.externalWidthNominal;
    newState.externalHeightNominal = cartItem.externalHeightNominal;
    newState.artworkWidthNominal = cartItem.artworkWidthNominal;
    newState.artworkHeightNominal = cartItem.artworkHeightNominal;
    newState.windowWidthNominal = cartItem.windowWidthNominal;
    newState.windowHeightNominal = cartItem.windowHeightNominal;
    newState.frameSelected = cartItem.frameSelected;
    newState.checked = cartItem.matBorderSelected;
    newState.matBorderCounter = cartItem.matBorderCounter;
    newState.matColorSelected = cartItem.matColorSelected;
    newState.isOverSized = cartItem.isOverSized;

    (newState.matteBoardHeight = cartItem.matteBoardHeight),
      (newState.matteBoardWidth = cartItem.matteBoardWidth),
      (newState.internalHeight = cartItem.internalHeight),
      (newState.internalWidth = cartItem.internalWidth),
      (newState.rabbetEdgeHeight = cartItem.rabbetEdgeHeight),
      (newState.rabbetEdgeWidth = cartItem.rabbetEdgeWidth),
      // Always show price for one on add-edit pages
      Calculator.setQuantity(1);

    this.setState(
      newState,
      function() {
        if (newState.section === "frame") {
          let status = Calculator.calculate();

          // console.log(Calculator, "==================");

          if (!status.success) {
            if (status.retry) {
              return;
            }

            newState.statusMsg = status.message;
          } else {
            newState.statusMsg = null;
            let node = document.getElementById("frame-builder-price");
            if (node !== null) {
              node.innerHTML =
                window.currency +
                Calculator.calculatedValues.totalCost +
                "<span> (Price includes delivery)</span>";
            }
          }

          if (newState.suggestedMatteWidth) {
            newState.matteWidth = Calculator.getMatteSuggestion();
          }
        }

        Calculator.calculate();

        const status = Calculator.calculate();

        if (status.success === false) {
          // setTimeout(function() {
          this.setState({
            statusMsg: status.message,
          });
          // }.bind(this), 300)
        } else {
          this.setState({
            statusMsg: null,
          });
          let node = document.getElementById("frame-builder-price");
          if (node !== null) {
            node.innerHTML =
              window.currency +
              Calculator.calculatedValues.totalCost +
              "<span> (Price includes delivery)</span>";
          }
        }

        // this.onResize();
        setTimeout(
          function() {
            this.onResize();
          }.bind(this),
          200
        );
      }.bind(this)
    );

    let numArr = [];

    let frame = Math.max(newState.artworkHeight, newState.artworkWidth);

    matteArray.forEach((num) => {
      if (num.frame > frame) {
        numArr.push(num.style);
      }
    });

    if (!cartItem.frameSelected) {
      this.onFrameChange(Utilities.setInitialFrameSize(numArr[0]).adminId);
      newState.frameId = Utilities.setInitialFrameSize(numArr[0]).adminId;
    }

    if (cartItem.frameSelected) {
      newState.frameId = cartItem.frameId;
    }

    // newState.frameId = Utilities.setInitialFrameSize(
    //   numArr[0],
    //   cartItem.frameId
    // ).adminId;

    !cartItem.frameSelected
      ? (newState.frameStyle = Utilities.setInitialFrameSize(
          numArr[0]
        ).description)
      : (newState.frameStyle = cartItem.frameStyle);

    //  ^^ COnditional above checks to see if the framestyle has been selected
    // If so, it retains the local state

    Calculator.setFrameStyle(newState.frameStyle);

    this.setState({ frameMinimum: numArr[0] });
  }

  dropdownChange(entry, a, b) {
    switch (entry.name) {
      case "hanging":
        Calculator.setHanging(entry.value);
        Calculator.calculate();
        this.setState(
          {
            hanging: entry.value,
          },
          function() {
            this.resaveToLocal();
            this.onResize();
          }
        );
        this.setState({
          statusMsg: "Please select a smaller matte width",
        });
        break;

      case "popular-sizes":
        if (entry.value !== null) {
          let values = entry.value.split("x");
          values[0] = parseFloat(values[0]);
          values[1] = parseFloat(values[1]);

          Calculator.setArtworkWidth(values[0]);
          Calculator.setArtworkHeight(values[1]);
          Calculator.calculate();

          this.setState(
            {
              artworkWidth: values[0],
              artworkHeight: values[1],
              frameWidthNominal: Calculator.calculatedValues.frameWidthNominal,
              frameHeightNominal:
                Calculator.calculatedValues.frameHeightNominal,
              externalWidthNominal:
                Calculator.calculatedValues.externalWidthNominal,
              externalHeightNominal:
                Calculator.calculatedValues.externalHeightNominal,
              artworkWidthNominal:
                Calculator.calculatedValues.artworkWidthNominal,
              artworkHeightNominal:
                Calculator.calculatedValues.artworkHeightNominal,
              windowWidthNominal:
                Calculator.calculatedValues.windowWidthNominal,
              windowHeightNominal:
                Calculator.calculatedValues.windowHeightNominal,
              matteBoardHeight: Calculator.calculatedValues.matteBoardHeight,
              matteBoardWidth: Calculator.calculatedValues.matteBoardWidth,
              internalHeight: Calculator.calculatedValues.internalHeight,
              internalWidth: Calculator.calculatedValues.internalWidth,
              rabbetEdgeHeight: Calculator.calculatedValues.rabbetEdgeHeight,
              rabbetEdgeWidth: Calculator.calculatedValues.rabbetEdgeWidth,
              customSizes: false,
              popularSize: entry.value,
            },
            function() {
              this.resaveToLocal();
            }
          );
        } else {
          this.setState(
            {
              customSizes: true,
              popularSize: entry.value,
            },
            function() {
              this.resaveToLocal();
            }
          );
        }

        break;

      case "style":
        console.log(entry.value2);
        this.onFrameChange(entry.value2);
        Calculator.setFrameStyle(entry.value);
        Calculator.calculate();

        this.setState(
          {
            frameStyle: entry.value,
            frameId: entry.value2,
            frameImgUrl: Calculator.getFrameImgUrl(),
            frameWidthNominal: Calculator.calculatedValues.frameWidthNominal,
            frameHeightNominal: Calculator.calculatedValues.frameHeightNominal,
            externalWidthNominal:
              Calculator.calculatedValues.externalWidthNominal,
            externalHeightNominal:
              Calculator.calculatedValues.externalHeightNominal,
            artworkWidthNominal:
              Calculator.calculatedValues.artworkWidthNominal,
            artworkHeightNominal:
              Calculator.calculatedValues.artworkHeightNominal,
            windowWidthNominal: Calculator.calculatedValues.windowWidthNominal,
            windowHeightNominal:
              Calculator.calculatedValues.windowHeightNominal,
            matteBoardHeight: Calculator.calculatedValues.matteBoardHeight,
            matteBoardWidth: Calculator.calculatedValues.matteBoardWidth,
            internalHeight: Calculator.calculatedValues.internalHeight,
            internalWidth: Calculator.calculatedValues.internalWidth,
            rabbetEdgeHeight: Calculator.calculatedValues.rabbetEdgeHeight,
            rabbetEdgeWidth: Calculator.calculatedValues.rabbetEdgeWidth,
            currentGalleryImage: null,
            frameSelected: true,
          },
          function() {
            this.resaveToLocal();
            this.onResize();
          }
        );
        break;

      case "backing":
        Calculator.setBacking(entry.value);
        this.setState({ backing: entry.value }, function() {
          this.resaveToLocal();
        });
        break;

      case "glazing":
        Calculator.setGlazing(entry.value);
        this.setState({ glazing: entry.value }, function() {
          this.resaveToLocal();
        });
        break;

      case "matte-color":
        this.resetState(entry.value);
        this.setState(
          {
            matColorSelected: true,
          },
          function() {
            this.resaveToLocal();
            this.onResize();
          }
        );
        break;

      default:
        break;
    }

    //Calculator.recalculate();
  }

  resetState(color, frame) {
    if (color) {
      Calculator.setMatteColor(color);
      this.setState({ matteColor: color }, function() {
        this.resaveToLocal();
        this.onResize();
      });
    }
    if (frame) {
      Calculator.setFrameStyle(frame);
      this.setState({ frameStyle: frame }, function() {
        this.resaveToLocal();
        this.onResize();
      });
    }
  }

  isValid = (field, value, keepError) => {
    let isValid = false;

    switch (field) {
      case "artworkHeight":
        isValid = Calculator.isValidArtworkDimension(
          this.state.artworkWidth,
          value
        );

        if (isValid !== true) {
          this.setState({
            statusMsg: isValid,
          });
          return false;
        }

        break;

      case "artworkWidth":
        isValid = Calculator.isValidArtworkDimension(
          value,
          this.state.artworkHeight
        );

        if (isValid !== true) {
          this.setState({
            statusMsg: isValid,
          });
          return false;
        }

        break;

      case "matteWidth":
        this.adjustFrameRatio();

        if (value < 0 || value > 40) {
          this.setState({
            statusMsg: "The matte width has to be between 0 and 40 cm",
          });
          return false;
        }

        if (
          value * 2 + 7 > this.state.artworkWidth ||
          value * 2 + 7 > this.state.artworkHeight
        ) {
          this.setState({
            statusMsg: "Please select a smaller matte width",
          });
          return false;
        }

        this.setState({
          suggestedMatteWidth: false,
        });

        break;
    }

    // if (!keepError) {

    // if ( (this.isValid("artworkWidth", this.state.artworkWidth, true)) && (this.isValid("artworkHeight", this.state.artworkHeight, true)) ) {
    //     return false;
    // }

    this.setState({
      statusMsg: null,
    });

    // }

    return true;
  };

  nextSection = (e) => {
    if (e.target.getAttribute("data-disabled") === "true") {
      return;
    }

    let id = window.location.href;
    id = id.substr(id.lastIndexOf("/") + 1);

    let cartItem = JSON.parse(localStorage.getItem(id));

    if (this.state.section === "size") {
      this.resaveToLocal();
      setTimeout(
        function() {
          window.location.href = "/build/frame/" + this.state.id;
        }.bind(this)
      );
    } else {
      this.setState(
        {
          addeddToCart: true,
        },
        function() {
          this.resaveToLocal();
          console.log(cartItem.frameId);

          setTimeout(function() {
            window.location.href = "/cart";
          });
        }.bind(this)
      );
    }
  };

  closeHelpModal = () => {
    this.setState({
      helpModal: null,
    });
  };

  handleInputChange = (name, value, isMatteInput) => {
    let newState = {};

    switch (name) {
      case "artworkHeight":
      case "artworkWidth":
        value = parseFloat(value);
        break;

      case "matteWidth":
        // if ( ( ((value * 2) + 7) > this.state.artworkWidth ) || ( ((value * 2) + 7) > this.state.artworkHeight ) ) {
        //     return false;
        // } else {
        value = parseFloat(value);
        // }
        break;

      default:
        break;
    }

    isMatteInput && this.applyMatteSuggestion(true);

    switch (name) {
      case "artworkHeight":
        Calculator.setArtworkHeight(value);
        break;
      case "artworkWidth":
        Calculator.setArtworkWidth(value);
        break;
      case "matteWidth":
        Calculator.setMatteWidth(value);
        break;
      default:
        break;
    }

    Calculator.calculate();

    this.setState({
      frameWidthNominal: Calculator.calculatedValues.frameWidthNominal,
      frameHeightNominal: Calculator.calculatedValues.frameHeightNominal,
      externalWidthNominal: Calculator.calculatedValues.externalWidthNominal,
      externalHeightNominal: Calculator.calculatedValues.externalHeightNominal,
      artworkWidthNominal: Calculator.calculatedValues.artworkWidthNominal,
      artworkHeightNominal: Calculator.calculatedValues.artworkHeightNominal,
      windowWidthNominal: Calculator.calculatedValues.windowWidthNominal,
      windowHeightNominal: Calculator.calculatedValues.windowHeightNominal,
      matteBoardHeight: Calculator.calculatedValues.matteBoardHeight,
      matteBoardWidth: Calculator.calculatedValues.matteBoardWidth,
      internalHeight: Calculator.calculatedValues.internalHeight,
      internalWidth: Calculator.calculatedValues.internalWidth,
      rabbetEdgeHeight: Calculator.calculatedValues.rabbetEdgeHeight,
      rabbetEdgeWidth: Calculator.calculatedValues.rabbetEdgeWidth,
      isOverSized: Utilities.isOverSized(
        Calculator.calculatedValues.matteBoardHeight,
        Calculator.calculatedValues.matteBoardWidth
      ),
    });

    newState[name] = value;

    this.setState(
      newState,
      function(state) {
        this.resaveToLocal();
        this.adjustFrameRatio();

        // setTimeout(function() {
        //     this.isValid(name, value)
        // }.bind(this), 100);
      }.bind(this)
    );

    this.setState({
      statusMsg: null,
    });

    const updatedMatColour = Utilities.setMatBorderColor(
      Calculator.calculatedValues.matteBoardHeight,
      Calculator.calculatedValues.matteBoardWidth
    );

    // this.state.matteColor = updatedMatColour;

    if (
      Utilities.isOverSized(
        Calculator.calculatedValues.matteBoardHeight,
        Calculator.calculatedValues.matteBoardWidth
      ) !== this.state.isOverSized
    ) {
      this.dropdownChange({
        name: "matte-color",
        value: updatedMatColour,
        value2: null,
        a: undefined,
        b: undefined,
      });
    }
  };

  applyMatteSuggestion = (isInputChange) => {
    this.setState({
      matBorderCounter: this.state.matBorderCounter + 1,
    });
    let newState = {};

    if (this.state.suggestedMatteWidth || isInputChange) {
      newState.suggestedMatteWidth = false;
      newState.matteWidth = 2;
    } else {
      newState.suggestedMatteWidth = true;
      newState.matteWidth = Calculator.getMatteSuggestion();
      console.log(Calculator.getMatteSuggestion());
    }

    Calculator.setMatteWidth(newState.matteWidth);
    Calculator.calculate();

    const updatedMatColour = Utilities.setMatBorderColor(
      Calculator.calculatedValues.matteBoardHeight,
      Calculator.calculatedValues.matteBoardWidth
    );

    newState.frameWidthNominal = Calculator.calculatedValues.frameWidthNominal;
    newState.frameHeightNominal =
      Calculator.calculatedValues.frameHeightNominal;
    newState.externalWidthNominal =
      Calculator.calculatedValues.externalWidthNominal;
    newState.externalHeightNominal =
      Calculator.calculatedValues.externalHeightNominal;
    newState.artworkWidthNominal =
      Calculator.calculatedValues.artworkWidthNominal;
    newState.artworkHeightNominal =
      Calculator.calculatedValues.artworkHeightNominal;
    newState.windowWidthNominal =
      Calculator.calculatedValues.windowWidthNominal;
    newState.windowHeightNominal =
      Calculator.calculatedValues.windowHeightNominal;
    newState.isOverSized = Utilities.isOverSized(
      Calculator.calculatedValues.matteBoardHeight,
      Calculator.calculatedValues.matteBoardWidth
    );

    if (
      Utilities.isOverSized(
        Calculator.calculatedValues.matteBoardHeight,
        Calculator.calculatedValues.matteBoardWidth
      ) !== this.state.isOverSized
    ) {
      this.dropdownChange({
        name: "matte-color",
        value: updatedMatColour,
        value2: null,
        a: undefined,
        b: undefined,
      });
    }
    (newState.matteBoardHeight = Calculator.calculatedValues.matteBoardHeight),
      (newState.matteBoardWidth = Calculator.calculatedValues.matteBoardWidth),
      (newState.internalHeight = Calculator.calculatedValues.internalHeight),
      (newState.internalWidth = Calculator.calculatedValues.internalWidth),
      (newState.rabbetEdgeHeight =
        Calculator.calculatedValues.rabbetEdgeHeight),
      (newState.rabbetEdgeWidth = Calculator.calculatedValues.rabbetEdgeWidth),
      this.setState(
        newState,
        function() {
          this.resaveToLocal();
          this.onResize();
        }.bind(this)
      );

    // this.state.matteColor = updatedMatColour;
  };

  adjustFrameRatio = () => {
    let frame = document.getElementById("main-frame");

    if (frame !== null) {
      setTimeout(
        function() {
          let frameWidth = frame.offsetWidth;
          let frameWidthRatio = frameWidth / this.state.externalWidthNominal;

          let frameHeight = this.state.externalHeightNominal * frameWidthRatio;

          let frameBorderReal = Calculator.calculatedValues.frameWidth;
          let frameBorderWidth =
            Calculator.calculatedValues.frameWidth * frameWidthRatio;
          let previewMatteWidth =
            Calculator.userFields.matteWidth * frameWidthRatio;

          let cropperHeight = Math.round(
            frameHeight - (frameBorderWidth + previewMatteWidth) * 2
          );
          let cropperWidth = Math.round(
            frameWidth - (frameBorderWidth + previewMatteWidth) * 2
          );
          cropperHeight++;
          cropperWidth++;

          let color = Calculator.getFrameStyleColor();
          let matteColor = Calculator.getMatteColorRGB();
          let frameImgUrl = Calculator.getFrameImgUrl();

          if (!Utilities.isENU(color)) {
            this.setState({
              cropperWidth: cropperWidth,
              cropperHeight: cropperHeight,
              frameHeight: frameHeight,
              frameWidth: frameWidth,
              frameWidthCalculated: frame.offsetWidth,
              frameColor: color,
              frameBorderReal: frameBorderReal,
              previewMatteColor: matteColor,
              frameBorderWidth: frameBorderWidth,
              previewMatteWidth: previewMatteWidth,
              frameImgUrl: frameImgUrl,
            });
          }
        }.bind(this)
      );
    }
  };

  reCrop = () => {
    this.setState(
      {
        previewImgLoaded: true,
        rawImage: this.state.originalImg,
        croppedImage: this.state.originalImg,
        isCropping: true,
        currentGalleryImage: null,
        zoomLevel: 0,
      },
      function() {
        this.onResize();

        setTimeout(function() {
          if (typeof Event === "function") {
            window.dispatchEvent(new Event("resize"));
          } else {
            var resizeEvent = window.document.createEvent("UIEvents");
            resizeEvent.initUIEvent("resize", true, false, window, 0);
            window.dispatchEvent(resizeEvent);
          }
        }, 100);
      }
    );
  };

  onFileChange = (e) => {
    let b64 = e.target.files;

    ExifRotate.getBase64String(
      b64,
      {
        max_size: 2400,
      },
      (base64) => {
        let cropOnZoomSet = this.state.cropOnZoomSet;

        if (!cropOnZoomSet) {
          cropOnZoomSet = true;

          setTimeout(
            function() {
              let image = document.getElementById("cropper");

              if (image !== undefined && image !== null) {
                image.addEventListener(
                  "zoom",
                  function(event) {
                    this.setState({
                      zoomLevel: event.detail.ratio,
                    });
                  }.bind(this)
                );
              }
            }.bind(this),
            500
          );
        }

        this.setState(
          {
            originalImg: base64,
            previewImg: base64,
            previewImgLoaded: true,
            rawImage: base64,
            croppedImage: base64,
            isCropping: true,
            currentGalleryImage: null,
            cropOnZoomSet: cropOnZoomSet,
          },
          function() {
            this.onResize();

            setTimeout(function() {
              if (typeof Event === "function") {
                window.dispatchEvent(new Event("resize"));
              } else {
                var resizeEvent = window.document.createEvent("UIEvents");
                resizeEvent.initUIEvent("resize", true, false, window, 0);
                window.dispatchEvent(resizeEvent);
              }
            }, 100);
          }
        );
      }
    );

    e.target.value = null;
  };

  triggerFileInput = () => {
    // var event = new MouseEvent('click', {
    //     'view': window,
    //     'bubbles': true,
    //     'cancelable': false
    // });
    //
    var node = document.getElementById("file-input");
    // node.dispatchEvent(event);

    var event = document.createEvent("MouseEvent");
    event.initEvent("click", false, true);
    node.dispatchEvent(event);
    console.log(this.state.previewMatteWidth);
  };

  cropperZoomIn = () => {
    this.refs.cropper.zoom(0.01);
  };

  cropperZoomOut = () => {
    this.refs.cropper.zoom(-0.01);
  };

  fitToFrame = () => {
    this.setState(
      {
        zoomLevel: 0,
      },
      function() {
        this.refs.cropper.zoom(-100);
      }
    );
  };

  onResize = () => {
    this.adjustFrameRatio();
  };

  handleCropZoom = (zoomLevel) => {
    this.setState(
      {
        zoomLevel: zoomLevel,
      },
      function() {
        this.refs.cropper.zoomTo(zoomLevel);
      }
    );
  };

  render() {
    let builderDOM = "";

    let tableStandNotAllowed = Calculator.isNotAllowedHangingComponent(
      "Table Stand"
    );

    if (tableStandNotAllowed && this.state.hanging === "Table Stand") {
      this.dropdownChange({
        name: "hanging",
        value: "Not Selected",
      });
    }

    if (this.state.section === "size") {
      builderDOM = (
        <div className='frame-builder' data-section='size'>
          <div style={{ maxWidth: 1100 }}>
            <MetaTags>
              <meta
                id='meta-description'
                name='description'
                content='Design and build your custom frame online today with our simple to use online frame builder. Custom picture framing has never been simpler.'
              />
            </MetaTags>

            <div className='right right_size'>
              <h1>Measure your item from edge to edge</h1>
              <p className='guide'>
                Please measure your item to the nearest millimetre (mm). For
                example, if your artwork is 305 mm please enter 30.5 cm.
              </p>
              <div className='width-height-selector'>
                <div className='form-group form-group_size'>
                  <label>Height (cm)</label>
                  {this.state.customSizes ? (
                    <input
                      placeholder='Height'
                      defaultValue={this.state.artworkHeight}
                      onChange={(e) => {
                        this.state.frameSelected = false;
                        this.handleInputChange("artworkHeight", e.target.value || '43.2');
                      }}
                    />
                  ) : (
                    <input
                      disabled
                      value={this.state.artworkHeight}
                      type='text'
                    />
                  )}
                </div>
                <span className='x'>x</span>
                <div className='form-group  form-group_size'>
                  <label>Width (cm)</label>
                  {this.state.customSizes ? (
                    <input
                      placeholder='Width'
                      defaultValue={this.state.artworkWidth}
                      onChange={(e) => {
                        this.state.frameSelected = false;
                        this.handleInputChange("artworkWidth", e.target.value || '27.9');
                      }}
                    />
                  ) : (
                    <input
                      disabled
                      value={this.state.artworkWidth}
                      type='text'
                    />
                  )}
                </div>
              </div>

              {/* <div className='form-group popular-sizes'>
                <label>Select one of our popular sizes</label>
                <DropdownSelect
                  type='regular'
                  name='popular-sizes'
                  onChange={e => this.dropdownChange(e)}
                  items={Calculator.getPopularSizes()}
                  value={Calculator.getDefinitionByTypeValue(
                    "popular-size",
                    this.state.popularSize
                  )}
                />
              </div> */}

              <button
                className='next-btn btn_size'
                data-disabled={this.state.statusMsg === null ? false : true}
                onClick={(e) => this.nextSection(e)}
              >
                Next step
              </button>
              <WarningMessage message={this.state.statusMsg} />
            </div>
          </div>
          <div className='review_measure_box'>
            <div className='text_area'>
              <h1>Review our measurement instructions</h1>{" "}
              <h2>
                Our video below will guide you through measuring your artwork
                correctly. For a text based version of this video, please visit
                our{" "}
                <a
                  href='https://blog.frameit.com.sg/how-to/measuring-artwork-correctly/'
                  target='_blank'
                >
                  measurement article here.
                </a>
              </h2>{" "}
            </div>
            <div className='video_area'>
              {!this.state.videoClicked && (
                <div
                  className='video_image'
                  onClick={(e) => {
                    e.preventDefault();
                    let el = document.getElementById("player");
                    el.src += "?autoplay=1";
                    this.setState({ videoClicked: true });
                  }}
                >
                  <div className='video_button'>
                    <Ellipse className='one' />
                    <Ellipse2 className='two' />
                    <Polygon className='three' />
                  </div>
                  <img src={VideoImage} alt='' />
                </div>
              )}
              <iframe
                className='builder_video'
                allowfullscreen='allowfullscreen'
                mozallowfullscreen='mozallowfullscreen'
                msallowfullscreen='msallowfullscreen'
                oallowfullscreen='oallowfullscreen'
                webkitallowfullscreen='webkitallowfullscreen'
                id='player'
                style={{
                  display: this.state.videoClicked ? "block" : "none",
                }}
                ref={this.youtube}
                src='https://www.youtube.com/embed/dBvV2kAfxbI'
                frameborder='0'
                allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture allowfullscreen'
              ></iframe>
            </div>
          </div>
        </div>
      );
    } else if (this.state.section === "frame") {
      builderDOM = (
        <div>
          <div className='frame-builder' data-section='frame'>
            <div style={{ maxWidth: 1100 }}>
              <div className='left'>
                {this.state.currentGalleryImage && (
                  <div className='selected-gallery-image'>
                    <img
                      src={
                        "https://s3-ap-southeast-1.amazonaws.com/frameitsg/frame-images/image-" +
                        this.state.currentGalleryImage.headerId +
                        "-" +
                        this.state.currentGalleryImage.frameId +
                        "-" +
                        this.state.currentGalleryImage.frameFileName
                      }
                    />
                  </div>
                )}
                <div
                  className='frame-wrapper'
                  style={{
                    maxWidth:
                      this.state.artworkWidth < this.state.artworkHeight &&
                      this.state.artworkHeight > 15
                        ? (this.state.artworkWidth / this.state.artworkHeight) *
                            540 +
                          "px"
                        : "unset",
                  }}
                >
                  {!this.state.currentGalleryImage && (
                    <div
                      className='frame'
                      data-loaded={this.state.previewImgLoaded}
                      id='main-frame'
                      style={{
                        height: this.state.frameHeight,
                        borderColor: Utilities.isENU(this.state.frameColor)
                          ? "#fff"
                          : "#" + this.state.frameColor,
                        borderWidth: this.state.frameBorderWidth,
                        backgroundColor: Utilities.isENU(
                          this.state.previewMatteColor
                        )
                          ? "#fff"
                          : this.state.checked &&
                            "#" + this.state.previewMatteColor,
                        borderImageWidth: this.state.frameBorderWidth + "px",
                        borderImageSource: Utilities.isENU(
                          this.state.frameImgUrl
                        )
                          ? "unset"
                          : "url('" + this.state.frameImgUrl + "')",
                        borderImageRepeat: Utilities.isENU(
                          this.state.frameImgUrl
                        )
                          ? "unset"
                          : "stretch",
                        borderImageSlice: ((Utilities.isENU(
                          this.state.frameImgUrl
                        )
                          ? "unset"
                          : 86): "unset"),
                      }}
                    >
                      <div
                        className='matte'
                        id='main-matte'
                        style={{
                          // borderColor: ( (Utilities.isENU(this.state.previewMatteColor)) ? "#fff" : "#" + this.state.previewMatteColor ),
                          borderWidth:
                            this.state.checked && this.state.previewMatteWidth,
                        }}
                      >
                        <div
                          className='image-container'
                          style={{
                            backgroundImage:
                              this.state.previewImg !== null
                                ? `url('${this.state.previewImg}')`
                                : null,
                          }}
                        >
                          {this.state.isCropping && (
                            <div className='cropper' id='cropper'>
                              <Cropper
                                ref='cropper'
                                src={this.state.rawImage}
                                guides={false}
                                aspectRatio={
                                  this.state.cropperWidth /
                                  this.state.cropperHeight
                                }
                                style={{
                                  width: this.state.cropperWidth + "px",
                                  height: this.state.cropperHeight + "px",
                                }}
                                rotatable={false}
                                zoomable={true}
                                dragMode='move'
                                cropBoxMovable={false}
                                viewMode={3}
                                autoCropArea={1}
                                onZoom={() => {}}
                              />
                              <div className='crop-options clearfix'>
                                <button onClick={() => this.cropperZoomIn()}>
                                  <ZoomInIcon />
                                </button>
                                <button onClick={() => this.cropperZoomOut()}>
                                  <ZoomOutIcon />
                                </button>
                              </div>
                            </div>
                          )}
                          {this.state.previewImg !== null &&
                            !this.state.isCropping && (
                              <img
                                onClick={() => this.triggerFileInput()}
                                src={this.state.previewImg}
                              />
                            )}
                          {this.state.previewImg === null && <ImageIcon />}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                <div className='image-collection clearfix'>
                  <div className='header'>
                    <BackToBuilderImage
                      onClick={() => {
                        this.setState(
                          {
                            currentGalleryImage: null,
                          },
                          function() {
                            this.onResize();
                          }
                        );
                      }}
                    />
                  </div>
                  {this.state.currentCollection.map((item) => {
                    if (!item.headerFileName) return null;
                    return (
                      <div
                        className='header'
                        onClick={() => {
                          this.selectGalleryImage(item);
                        }}
                      >
                        <img
                          src={
                            "https://s3-ap-southeast-1.amazonaws.com/frameitsg/frame-images/header-" +
                            item.headerFileName
                          }
                        />
                      </div>
                    );
                  })}
                </div>
                <div className='image-options'>
                  {this.state.previewImgLoaded ? (
                    <div>
                      {this.state.isCropping && (
                        <div className='slider-wrapper'>
                          <label>Zoom</label>
                          <Slider
                            min={0.2}
                            max={1}
                            step={0.1}
                            value={this.state.zoomLevel}
                            ref='zoomSlider'
                            onChange={(a) => {
                              this.handleCropZoom(a);
                            }}
                          />
                        </div>
                      )}
                      {this.state.isCropping && (
                        <button
                          className='icon-button reverse'
                          onClick={() => {
                            this.fitToFrame();
                          }}
                        >
                          <FitIcon />
                          <span>Fit frame</span>
                        </button>
                      )}
                      {!this.state.isCropping && (
                        <button
                          className='remove-btn icon-button'
                          onClick={() => {
                            this.removeImage();
                          }}
                        >
                          <RemoveIcon />
                          <span>Remove</span>
                        </button>
                      )}
                      {this.state.isCropping && (
                        <button
                          className='remove-btn icon-button'
                          onClick={() => {
                            this.cancelCrop();
                          }}
                        >
                          <RemoveIcon />
                          <span>Cancel</span>
                        </button>
                      )}
                      {!this.state.isCropping && (
                        <button
                          className='icon-button'
                          onClick={() => {
                            this.reCrop();
                          }}
                        >
                          <CropIcon />
                          <span>Crop</span>
                        </button>
                      )}
                      {this.state.isCropping && (
                        <button
                          className='icon-button'
                          onClick={() => {
                            this.crop();
                          }}
                        >
                          <DoneIcon />
                          <span>Done</span>
                        </button>
                      )}
                    </div>
                  ) : (
                    <div>
                      <button
                        className='icon-button'
                        onClick={() => {
                          this.triggerFileInput();
                        }}
                      >
                        <UploadIcon />
                        <span>Upload</span>
                      </button>
                    </div>
                  )}
                  <div className='disclaimer_area'>
                    <img src={DisclaimerImage} />
                    <p className='disclaimer'>
                      If you require printing, please contact us for options and
                      pricing.
                    </p>
                  </div>
                </div>
              </div>
              <div className='right'>
                <div className='cut-fitter'></div>
                <div className='cont'>
                  <h1>Building your custom frame</h1>
                  {(Calculator.calculatedValues.artworkHeightNominal > 69 ||
                    Calculator.calculatedValues.artworkWidthNominal > 69) && (
                    <div className='frame_size_warning'>
                      <div></div>
                      <p>
                        Based on your artwork size, you need a frame{" "}
                        <span>{this.state.frameMinimum}cm</span> or wider
                      </p>
                    </div>
                  )}
                  <div className='form-group'>
                    <label>Frame style</label>
                    <DropdownSelect
                      type='style'
                      name='style'
                      value={Calculator.getDefinitionByTypeValue(
                        "frame",
                        this.state.frameStyle
                        // Calculator.getFrameStyles(this.state.frameMinimum, true)
                      )}
                      items={Calculator.getFrameStyles(this.state.frameMinimum)}
                      disabled={this.state.isCropping}
                      onChange={(e) => this.dropdownChange(e)}
                      minFrameSize={this.state.frameMinimum}
                    />
                  </div>
                  <div className='form-group border_form'>
                    <label className='help'>Mat Border?</label>
                    <div
                      className={
                        "switch_box " + (this.state.checked && "switch_box_on")
                      }
                    >
                      <h1
                        style={{
                          color: !this.state.checked ? "white" : "black",
                        }}
                      >
                        No
                      </h1>
                      <Switch
                        onChange={(e) => this.handleMatBorderChange(e)}
                        width={80}
                        checked={this.state.checked}
                      />
                      <h1
                        style={{
                          color: this.state.checked ? "white" : "black",
                        }}
                        className='yes'
                      >
                        Yes
                      </h1>
                    </div>
                  </div>{" "}
                  {this.state.checked && (
                    <div className='form-group mat-width'>
                      <label className='help'>
                        Mat width
                        <span className='measure'>cm</span>
                        <HelpIcon
                          onClick={() => {
                            this.setState({
                              helpModal: "Mat width",
                            });
                          }}
                        />
                      </label>
                      <input
                        disabled={this.state.isCropping}
                        placeholder=''
                        defaultValue={this.state.matteWidth}
                        onChange={(e) => {
                          this.handleInputChange(
                            "matteWidth",
                            e.target.value,
                            true
                          );
                        }}
                        key={
                          this.state.suggestedMatteWidth
                            ? "suggested"
                            : "not-suggested"
                        }
                      />
                      {/*<input
                                defaultValue={this.state.matteWidth}
                                type="number"
                                onChange={(e) => { this.handleInputChange("matteWidth", e.target.value) } } type="text"
                            />*/}
                      {/* <span className='info'>(Enter 0 for no mat)</span> */}
                      {this.state.suggestedMatteWidth ? (
                        <button
                          className={
                            "active" +
                            (this.state.isCropping ? " disabled" : "")
                          }
                          onClick={() => {
                            this.applyMatteSuggestion();
                          }}
                        >
                          Recommendation applied
                        </button>
                      ) : (
                        <button
                          className={
                            "" + (this.state.isCropping ? " disabled" : "")
                          }
                          onClick={() => {
                            this.applyMatteSuggestion();
                          }}
                        >
                          Apply Recommendation
                        </button>
                      )}
                    </div>
                  )}
                  {this.state.checked && (
                    <div className='form-group'>
                      <label className='help'>Mat colour</label>
                      <DropdownSelect
                        height={
                          Calculator.calculatedValues.artworkHeightNominal
                        }
                        width={Calculator.calculatedValues.artworkWidthNominal}
                        type='color'
                        name='matte-color'
                        value={Calculator.getDefinitionByTypeValue(
                          "matte-color",
                          this.state.matteColor,
                          Utilities.isOverSized(
                            Calculator.calculatedValues.matteBoardHeight,
                            Calculator.calculatedValues.matteBoardWidth
                          )
                        )}
                        items={Calculator.getMatteColors(
                          Calculator.calculatedValues.matteBoardHeight,
                          Calculator.calculatedValues.matteBoardWidth
                        )}
                        onChange={(e) => this.dropdownChange(e)}
                      />
                    </div>
                  )}
                  <div className='form-group'>
                    <label className='help'>
                      Glazing
                      <HelpIcon
                        onClick={() => {
                          this.setState({
                            helpModal: "Glaze Options",
                          });
                        }}
                      />
                    </label>
                    <DropdownSelect
                      type='glazing'
                      name='glazing'
                      value={Calculator.getDefinitionByTypeValue(
                        "glazing",
                        this.state.glazing
                      )}
                      items={Calculator.getGlazings()}
                      onChange={(e) => this.dropdownChange(e)}
                    />
                  </div>
                  <div
                    className='form-group advanced-options'
                    data-open={this.state.advancedOptionsDropdown}
                  >
                    <button
                      onClick={() => {
                        this.setState({
                          advancedOptionsDropdown: !this.state
                            .advancedOptionsDropdown,
                        });
                      }}
                    >
                      <span>Advanced Options</span>
                      <DropdownOrangeIcon />
                    </button>
                    {this.state.advancedOptionsDropdown && (
                      <div>
                        <label className='control control--checkbox'>
                          Table Stand
                          <input
                            checked={this.state.hanging === "Table Stand"}
                            onChange={() => {
                              this.dropdownChange({
                                name: "hanging",
                                value:
                                  this.state.hanging === "Table Stand"
                                    ? "Not Selected"
                                    : "Table Stand",
                              });
                            }}
                            id='terms'
                            type='checkbox'
                            disabled={Calculator.isNotAllowedHangingComponent(
                              "Table Stand"
                            )}
                            defaultValue='checked'
                          />
                          {tableStandNotAllowed && (
                            <span>Not available for your size of frame</span>
                          )}
                          <div className='control__indicator'></div>
                        </label>
                      </div>
                    )}
                  </div>
                  <div className='overview'>
                    <div className='price'>
                      <label>Price: </label>
                      <p
                        id='frame-builder-price'
                        dangerouslySetInnerHTML={{
                          __html: Utilities.isENU(
                            Calculator.calculatedValues.totalCost
                          )
                            ? "To be calculated"
                            : window.currency +
                              parseInt(Calculator.calculatedValues.totalCost) +
                              " <span> (Price includes delivery)</span>",
                        }}
                      ></p>
                    </div>
                    <h3>Overview</h3>
                    <div>
                      <div className='detail'>
                        <div className='field'>Artwork Size</div>
                        <div className='value'>
                          {Calculator.calculatedValues.artworkHeightNominal ===
                            0 ||
                          Utilities.isENU(
                            Calculator.calculatedValues.artworkHeightNominal
                          )
                            ? "To be calculated"
                            : Calculator.calculatedValues.artworkHeightNominal +
                              " cm x " +
                              Calculator.calculatedValues.artworkWidthNominal +
                              " cm"}
                          <a href={"/build/size/" + this.state.id}>Edit</a>
                        </div>
                      </div>
                      <div className='detail'>
                        <div className='field'>Frame style</div>
                        <div className='value'>
                          {Utilities.isENU(Calculator.userFields.frameType)
                            ? "To be calculated"
                            : Utilities.capitalize(
                                Calculator.userFields.frameType
                                  .replace("<strong>", "")
                                  .replace("</strong>", "")
                              )}
                        </div>
                      </div>
                      <div className='detail'>
                        <div className='field'>Frame width</div>
                        <div className='value'>
                          {Calculator.calculatedValues.frameWidth === 0 ||
                          Utilities.isENU(
                            Calculator.calculatedValues.frameWidth
                          )
                            ? "To be calculated"
                            : Calculator.calculatedValues.frameWidth + " cm"}
                        </div>
                      </div>
                      <div className='detail'>
                        <div className='field'>Mat width</div>
                        <div className='value'>
                          {Utilities.isENU(Calculator.userFields.matteWidth)
                            ? "To be calculated"
                            : Calculator.userFields.matteWidth + " cm"}
                        </div>
                      </div>
                      <div className='detail'>
                        <div className='field'>Mat colour</div>
                        <div className='value'>
                          {!this.state.checked ? (
                            <div>none</div>
                          ) : Utilities.isENU(
                              Calculator.userFields.matteColor
                            ) ? (
                            "To be calculated"
                          ) : (
                            Utilities.capitalize(
                              Calculator.userFields.matteColor
                            )
                          )}
                        </div>
                      </div>
                      {this.state.checked ?
                          <div className='detail'>
                            <div className='field'>
                              Window size
                              <HelpIcon
                                  style={{marginLeft: '10px'}}
                                  onClick={() => {
                                    this.setState({
                                      helpModal: "Window size",
                                    });
                                  }}
                              />
                            </div>
                            <div className='value'>
                              {this.state.windowHeightNominal +
                                  "cm  x " +
                                  this.state.windowWidthNominal +
                                  "cm"}
                            </div>
                          </div>
                          : null}
                    </div>
                    {!this.state.statusMsg && (
                      <p>
                        The external size of your frame will be roughly{" "}
                        <strong>
                          {Calculator.calculatedValues.externalHeightNominal} cm
                          x {Calculator.calculatedValues.externalWidthNominal}{" "}
                          cm
                        </strong>{" "}
                        based upon your selections.
                      </p>
                    )}
                  </div>
                  <WarningMessage message={this.state.statusMsg} />
                  <button
                    className='next-btn'
                    data-disabled={this.state.statusMsg === null ? false : true}
                    onClick={(e) => this.nextSection(e)}
                  >
                    Add to cart
                  </button>
                </div>
              </div>
            </div>
            <div className='frame_bottom_outer'>
              <FrameBuilderBottom />
            </div>
          </div>
        </div>
      );
    }

    return (
      <div
        className='frame-builder-container'
        data-section={this.state.section}
        data-cropping={this.state.isCropping}
      >
        <div className='navbar-background'></div>
        {!Utilities.isENU(this.state.statusMsgFull) ? (
          <div className='full-screen-error'>
            <h1>{this.state.statusMsgFull}</h1>
          </div>
        ) : (
          <div className='main-container-ex'>{builderDOM}</div>
        )}
        <HelpModal
          type={this.state.helpModal}
          open={this.state.helpModal !== null ? true : false}
          closeHelpModal={() => {
            this.closeHelpModal();
          }}
        />
        <input
          id='file-input'
          accept='image/*'
          type='file'
          name='cv'
          onChange={(e) => {
            this.onFileChange(e);
          }}
        />
        <ToastContainer store={ToastStore} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/FrameBuilder.js